<template>
    <div>
      <ServerError v-if="ServerError" />
      <vue-element-loading
        :active="appLoading"
        spinner="bar-fade-scale"
        color="black"
        size="128"
        is-full-screen
      />
      <v-snackbar v-model="showsnackbar" color="black" right>
        <v-layout wrap justify-center>
          <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
          <v-flex text-right>
            <v-btn small :ripple="false" text @click="showsnackbar = false">
              <v-icon style="color: white">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-snackbar>
      <v-layout wrap v-if="goals" pa-5>
        <v-flex xs12>
          <v-layout wrap>
            <v-flex xs12 text-left>
              <span style="color: #000; font-family: poppinsbold; font-size: 25px"
                >{{ goals.title }}</span
              >
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout wrap pa-5>
          <v-flex
            xs12
            sm6
            md4
            pa-2
            align-self-center
            v-for="(item, i) in goals.points"
            :key="i"
          >
            <v-card outlined height="200px">
              <v-layout wrap py-5 px-5>
                <v-flex xs12>
                  <span style="font-family: poppinsbold; font-size: 16px">
                    {{ item.heading }}
                    <br />
                    <br />
                    <span
                      style="
                        font-family: poppinsregular;
                        font-size: 14px;
                        text-align: justify;
                      "
                      >{{ item.description }}</span
                    >
                  </span>
                </v-flex>
                <v-layout wrap>
                <v-flex xs12 sm12 pa-2>
                  <v-btn
                    small
                    block
                    class="mr-2"
                    outlined
                    color="green"
                    @click="editSlider(item)"
                  >
                    Edit
                  </v-btn>
                </v-flex>
              </v-layout>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-dialog v-model="editdialog" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Blog</span>
          </v-card-title>
          <v-card-text>
            <v-layout wrap justify-center>
              <v-col cols="12" sm="12">
                <v-text-field
                  outlined
                  dense
                  v-model="editingitem.heading"
                  label="Heading"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-textarea
                  outlined
                  dense
                  v-model="editingitem.description"
                  label="Description"
                  required
                ></v-textarea>
              </v-col>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="editdialog = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="update(editingitem)">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-layout>
    </div>
  </template>
  <script>
  import axios from "axios";
//   import { VueEditor } from "vue2-editor";
  // import ImageComp from "@/components/Common/singleImages";
  export default {
    components: {
    //   VueEditor,
      // ImageComp,
    },
    data() {
      return {
        showsnackbar: false,
        ServerError: false,
        msg: null,
        appLoading: false,
        dialog: false,
        itemid: "",
        aboutBannerImage: "",
        about: {},
        goals:{},
        itemediting: [],
        editdialog: false,
          editingitem: {},
        officials: [],
        rules: {
          required: (value) => !!value || "Required.",
          min: (v) => v.length >= 8 || "Min 8 characters",
        },
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      winStepper(window_data) {
        if (window_data.type == "aboutBannerImage") {
          this.aboutBannerImage = window_data.selectedFiles;
        }
      },
      getData() {
        this.appLoading = true;
        axios({
          url: "/view/website/content",
          method: "GET",
          headers: {
            token: localStorage.getItem("token"),
          },
        })
          .then((response) => {
            this.appLoading = false;
            this.goals = response.data.websiteDetails.goals;
            this.officials = response.data.officials;
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      },
      update(editingitem) {
        var data = {};
        data["goals"] = editingitem;
        axios({
          url: "/edit/goals",
          method: "POST",
          data: data,
          headers: {
            token: localStorage.getItem("token"),
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status) {
              // if (this.aboutBannerImage) {
              //     this.uploadBannerImage();
              // }
              this.msg = "Edited Sucessfully";
              this.showsnackbar = true;
              this.editdialog = false;
              this.getData();
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      },
      editSlider(item) {
        this.editingitem = item;
        this.editdialog = true;
      },
    },
  };
  </script>
  <style scoped>
  .item_title {
    font-weight: bold;
    font-family: poppinssemibold;
  }
  </style>
    